import * as jwt from 'jsonwebtoken';

const LOCAL_STORAGE_TOKEN = 'token';

export const isLoggedInCustomer = auth => {
    if (auth && auth.token) {
        const decoded = decodeToken(auth.token);
        if (!decoded.role_id && decoded.customer_id) return true;
    }
    return false;
};

export const isLoggedInUser = auth => {
    if (auth && auth.token) {
        const decoded = decodeToken(auth.token);
        if (decoded.role_id && decoded.user_id) return true;
    }
    return false;
};

export const saveTokenToLocalStorage = ({token}) => {
    localStorage.setItem(LOCAL_STORAGE_TOKEN, token);
};

export const getTokenFromLocalStorage = () => {
    const authData = {
        token: localStorage.getItem(LOCAL_STORAGE_TOKEN),
    };
    return (authData.token) ? authData : {};
};

export const logoutCustomer = () => {
    localStorage.removeItem(LOCAL_STORAGE_TOKEN);
    // console.log("you have logged out!");
};

export const decodeToken = token => {
    return jwt.decode(token);
};
